import React from 'react';
import { Zap } from 'lucide-react';

export function WelcomeScreen() {
    return (
        <div className="flex flex-col items-center justify-center h-full gap-4 text-center">
            <Zap className="size-12 text-amber-400" />
            <h2 className="text-2xl font-bold text-gray-700">ברוכים הבאים לתיעוד API</h2>
            <p className="text-gray-500 max-w-sm">
                בחר אנדפוינט מהתפריט הצדדי כדי לצפות בתיעוד, לניסוי ולקבלת דוגמאות קוד.
            </p>
        </div>
    );
}
